import { render, staticRenderFns } from "./appMenu.vue?vue&type=template&id=075c733f&scoped=true&"
import script from "./appMenu.vue?vue&type=script&lang=js&"
export * from "./appMenu.vue?vue&type=script&lang=js&"
import style0 from "./appMenu.vue?vue&type=style&index=0&id=075c733f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c733f",
  null
  
)

export default component.exports